import { useEffect, useState } from "react";
import HomeHeader from "layouts/homeHeader";
import HomeNavbar from "layouts/homeNavbar";
import BackgroundImage from "assets/images/header.webp";
import { NavLink, Outlet } from "react-router-dom";
import { history } from "index";
import { useNavigate } from "react-router-dom";
import styles from "./style.module.scss";
import SettingsIcon from "assets/icons/setting.svg";
import ChatIcon from "assets/icons/chat.svg";
import AnnouncementIcon from "assets/icons/announcement.svg";
import HamburgerIcon from "assets/icons/hamburger.svg";
import SearchIcon from "assets/icons/search.svg";
import { useParams } from "react-router-dom";
import { InstallationModelResponse } from "types";
import axios from "axios";
import { useKeycloak } from "@react-keycloak/web";
import { locationController } from "utils/locationhelper";
import AuthService from "services/AuthService";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import LoaderSpinner from "components/UI/LoaderSpinner/LoaderSpinner";

const TesisatDetay = () => {
  const { id } = useParams();
  const [installationDetail, setInstallationDetail] = useState<InstallationModelResponse>();
  const [isLoading, setIsLoading] = useState(false);
  const [grafikUr, setGrafikUr] = useState(`/tesisat-detaylari/${id}/durum-grafikleri`);
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();

  const auth = new AuthService(keycloak);

  let companyId = locationController();

  useEffect(() => {
    if (history.location.pathname === "/tesisat-detaylari") {
      // console.log("test");
      navigate("/tesisat-detaylari/durum-grafikleri");
    }
  }, []);

  useEffect(() => {
    if (id) {
      setGrafikUr(`/tesisat-detaylari/${id}/durum-grafikleri`);
    }
  }, [id]);


  const getInstallationDetail = async () => {

    auth.axios(`/InstallationOperations/GetInstallationInfo`, null,
      {
        email: keycloak?.tokenParsed?.email,
        companyId: companyId,
        pageSize: 25,
        page: 1,
        tesisatNo: id
      }).then(response => {

        setIsLoading(false);

        if (response.data.success === true) {

          setInstallationDetail(response.data?.data?.filter((row: any) => row.tesisatNo === id))
        }
        else {
          if (response.data.message) {
            toast.error(response.data.message, {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored"
            });
          }
        }


      }).catch(err => {
        setIsLoading(false);

        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored"
        });


      });


  }

  useEffect(() => {
    getInstallationDetail()
  }, []);



  return (
    <div>
      <ToastContainer />
      <div className={styles.tesisatDetaylari}>
        <div className={styles.left}>
          <HomeNavbar />
        </div>
        <div className={styles.right}>
          <HomeHeader
            title={`${id} nolu tesisat detayları`}
            announcementIcon={AnnouncementIcon}
            chatIcon={ChatIcon}
            hamburgerIcon={HamburgerIcon}
            personal="#fff"
            settingsIcon={SettingsIcon}
            background={BackgroundImage}
            color={"#fff"}
          />
          <div className={styles.bodyArea}>
            <div className={styles.tableContainer}>
              <div className={styles.card}>
                <div>Tesisat No</div>
                <div>{id}</div>
              </div>
              <div className={styles.card}>
                <div>Tahakkuk Çarpanı</div>
                <div>{installationDetail?.[0].tahakkukCarpani}</div>
              </div>
              <div className={styles.card}>
                <div>Sayaç Seri No</div>
                <div>{installationDetail?.[0].sayacSeriNo}</div>
              </div>
              <div className={styles.card}>
                <div>Adres</div>
                <div>{installationDetail?.[0].adres}</div>
              </div>
            </div>
            <div className={styles.tableContainer}>
              <div className={styles.card}>
                <div>Muhattap No</div>
                <div>{installationDetail?.[0].muhattapNo}</div>
              </div>
              <div className={styles.card}>
                <div>Abone Adı Soyadı</div>
                <div>{installationDetail?.[0].aboneAdiSoyadi}</div>
              </div>
              <div className={styles.card}>
                <div>Sayaç / Marka Model</div>
                <div>{installationDetail?.[0].sayacMarka}</div>
              </div>
            </div>
          </div>
          {isLoading ? <LoaderSpinner /> : ""}
          <div className={styles.navigation}>
            <NavLink to={grafikUr}>
              {({ isActive }) =>
                isActive ? (
                  <div className={styles.itemActive}>Durum Grafikleri</div>
                ) : (
                  <div className={styles.item}>Durum Grafikleri</div>
                )
              }
            </NavLink>
            <NavLink to={`/tesisat-detaylari/` + id + "/yuk-profili"}>
              {({ isActive }) =>
                isActive ? (
                  <div className={styles.itemActive}>Yük Profili</div>
                ) : (
                  <div className={styles.item}>Yük Profili</div>
                )
              }
            </NavLink>
            <NavLink to={`/tesisat-detaylari/` + id + "/osf"}>
              {({ isActive }) =>
                isActive ? (
                  <div className={styles.itemActive}>OSF</div>
                ) : (
                  <div className={styles.item}>OSF</div>
                )
              }
            </NavLink>
            <NavLink to={`/tesisat-detaylari/` + id + "/gun-bazinda-endex"}>
              {({ isActive }) =>
                isActive ? (
                  <div className={styles.itemActive}>Gün Bazında Endeks</div>
                ) : (
                  <div className={styles.item}>Gün Bazında Endeks</div>
                )
              }
            </NavLink>
            <NavLink to={`/tesisat-detaylari/` + id + "/aylik-endex"}>
              {({ isActive }) =>
                isActive ? (
                  <div className={styles.itemActive}>Aylık Endeks</div>
                ) : (
                  <div className={styles.item}>Aylık Endeks</div>
                )
              }
            </NavLink>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default TesisatDetay;
